import React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  builtinAvatarDataUrl,
  DEFAULT_BUILTIN_AVATAR_ID,
} from '../services/builtinAvatars';

// Children for a MUI <Avatar> — rendered only when there's no usable image
// (empty src, or the image failed to load). Either way the user has no usable
// avatar right now: they never set one (the server's "/default-avatar.svg"
// placeholder resolves to an empty src, see resolveAvatarUrl), or their
// uploaded photo 404s (uploads that predate the persistent cc-uploads volume
// were wiped by container rebuilds). Both get the house default: builtin
// avatar 01 tinted to match the active theme — blue on midnight, leaf green
// on sesh (palette.custom.avatarDefaultTint). The initial letter survives
// only as a last resort should the builtin templates ever fail to resolve.
const AvatarFallback = ({ letter }) => {
  const theme = useTheme();
  const src = builtinAvatarDataUrl(
    DEFAULT_BUILTIN_AVATAR_ID,
    theme.palette.custom.avatarDefaultTint
  );
  return src ? (
    <img
      src={src}
      alt=""
      draggable={false}
      style={{ width: '100%', height: '100%' }}
    />
  ) : (
    letter || null
  );
};

export default AvatarFallback;
